// extracted by mini-css-extract-plugin
module.exports = {"card":"ResCard_card__1v2Ml","card__img":"ResCard_card__img__2mGgl","win":"ResCard_win__1ztJe","draw":"ResCard_draw__2tkLR","lose":"ResCard_lose__3j4Pf"};